import { cn } from "@/lib/utils";

interface JobChipProps {
  children: React.ReactNode;
  className?: string;
}

const JobChip = ({ children, className }: JobChipProps) => {
  return (
    <span
      className={cn(
        "inline-flex items-center px-3 py-1.5 bg-sand-100 text-forest-800 rounded-full text-small font-medium",
        className
      )}
    >
      {children}
    </span>
  );
};

export { JobChip };